import './website.scss';
import './scripts/popup.js';
import './scripts/vendors.js';
import './scripts/form-loader.js';
import './scripts/barcode-reader.js';
import './scripts/date-picker.js';
import './scripts/autocomplete-input.js';
import './scripts/scanner-input.js';
import './scripts/debounce.js';
import './scripts/confirm-dialog.js';
import './scripts/pincode-entry.js';
import './scripts/multiple-emails.js';
import './scripts/stripeCalculation.js';
import './scripts/sortable.js';
import './scripts/ajax-post.js';
import './scripts/numeric-masking.js';


// WEBPACK FOOTER //
// ./resources/assets/website/main.js